import { render, staticRenderFns } from "./companyAdmin.vue?vue&type=template&id=47943dfe&scoped=true&"
import script from "./companyAdmin.vue?vue&type=script&lang=js&"
export * from "./companyAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47943dfe",
  null
  
)

export default component.exports